import { CommonOktaStyling } from './CommonStyling';
import classess from './OktaSignInWidget.scss';
import { maskEmail } from './oktaUtils';

function loader(spinnerGif) {
  if (!document.querySelector('#loader')) {
    const signIn = document.querySelector('#okta-sign-in');
    const loader = document.createElement('div');
    loader.id = 'loader';
    loader.style.position = 'absolute';
    loader.style.top = '0';
    loader.style.left = '0';
    loader.style.right = '0';
    loader.style.bottom = '0';
    loader.style.backgroundColor = 'white';
    loader.style.justifyContent = 'center';
    loader.style.alignItems = 'center';
    loader.style.zIndex = '9999';
    loader.style.display = 'none';
    const loaderImage = document.createElement('img');
    loaderImage.src = spinnerGif;
    loaderImage.alt = 'Loading....';
    loaderImage.style.width = '200px';
    loaderImage.style.height = '200px';
    loader.appendChild(loaderImage);
    signIn.appendChild(loader);
  }
}

function inputButton(){
  const inputButton = document.querySelector('input[type="submit"]');
  if (inputButton) {
    const primaryButton = document.createElement('button');
    primaryButton.type = 'submit';
    primaryButton.textContent = inputButton.value;
    primaryButton.classList.add(classess.button,'button-primary');
    primaryButton.setAttribute('data-type',inputButton.getAttribute('data-type'));
    primaryButton.style.width = '100%';
    primaryButton.style.height = CommonOktaStyling.HEIGHT_L;
    primaryButton.style.fontWeight = CommonOktaStyling.FONT_WEIGHT_BOLD;
    primaryButton.style.border = CommonOktaStyling.BORDER;
    primaryButton.style.borderRadius = CommonOktaStyling.BORDER_RADIUS;
    primaryButton.style.color = CommonOktaStyling.TEXT_COLOR_BLACK;
    primaryButton.style.background = CommonOktaStyling.BACKGROUND_COLOR_BUTTON;
    primaryButton.style.textTransform = CommonOktaStyling.TEXT_TRANSFORM_UPPERCASE;
    primaryButton.style.boxShadow = 'none';
    inputButton.parentElement.replaceChild(primaryButton,inputButton);
  }
}

function footer(){
  const authFooter = document.querySelector('#okta-sign-in .auth-footer');
  if (authFooter) {
    authFooter.style.display = 'block';
    authFooter.childNodes.forEach((ele) => {
      ele.style.color = CommonOktaStyling.TEXT_COLOR_BLUE;
      ele.style.fontSize = CommonOktaStyling.FONT_SIZE_SM;
      ele.style.lineHeight = CommonOktaStyling.LINE_HEIGHT_S;
      ele.style.fontWeight = CommonOktaStyling.FONT_WEIGHT_SEMI_BOLD;
      ele.style.display = 'block';
      ele.classList.add(classess.textSizeS);
    });
  }
}

function OktaHeadEmailCssAlt (){
  const emailElement = document.querySelector('#okta-sign-in .siw-main-view .siw-main-body .identifier');
  if(emailElement){
    emailElement.textContent = maskEmail(emailElement.textContent);
    emailElement.classList.add(classess.emailText);
  }
}

export default function OktaCommonCss(spinnerGif) {
  
  loader(spinnerGif);
  OktaHeadEmailCssAlt();

  const modalCancel = document.getElementById('okta-widget-modal-cancel');
  if (modalCancel) {
    modalCancel.style.display = 'block';
    modalCancel.style.top = "10px";
  }

  const errorContent= document.querySelector('.auth-content .siw-main-body .infobox-error');
  if(errorContent){
    errorContent.style.width='95%';
  }
  const mainContainerTag = document.querySelector('#okta-sign-in');
  if(mainContainerTag){
    mainContainerTag.classList.add(classess.mainContainer);
  }

  const anchorTag = document.querySelectorAll('#okta-sign-in a');
  if(anchorTag){
    anchorTag.forEach(element => {
      element.style.textDecoration = 'none';
      if (!(['Select', 'Receive a voice call instead'].includes(element.textContent))) {
        element.classList.add(classess.anchorTagStyle);
      }
    });
  }

  const headerElement = document.querySelector('#okta-sign-in > div.okta-sign-in-header.auth-header');
  if (headerElement) {
    headerElement.style.display = 'none';
  }

  const content = document.querySelector('#okta-sign-in > div.auth-content');
  if (content) {
    content.style.padding = CommonOktaStyling.PADDING_BOX ;
  }

  // remove margins from top and bottom
  const mainContainer = document.querySelector('#okta-sign-in.auth-container.main-container');
  mainContainer.style.marginTop = CommonOktaStyling.MARGIN_NONE;
  mainContainer.style.marginBottom = CommonOktaStyling.MARGIN_NONE;
  mainContainer.style.fontFamily= "'open sans', sans-serif";
  

  const titleElement = document.querySelector('.okta-form-title');
  if (titleElement) {
    titleElement.textContent = 'Log Into SCE.com';
    titleElement.classList.add(classess.popUpTitle);
  }

  const label = document.querySelectorAll('#okta-sign-in.auth-container .okta-form-label');
  if (label) {
    label.forEach(el => {
      if (!el.innerHTML.includes('*')) {
        el.innerHTML += '<span style="color: #BB0000;">*</span>';
      }
      if(el.innerHTML.includes('Username')){
        el.innerHTML = el.innerHTML.replace('Username','Email');
      }
      el.childNodes[0].classList.add(classess.formLabel);
    });
  }

  inputButton();

  footer();

  const warningIcon = document.querySelector('#okta-sign-in .infobox-warning > .icon');
  if(warningIcon){
    warningIcon.classList.add(classess.warningIcon);
  }

  const warningIconDiv = document.querySelector('#okta-sign-in .infobox-warning');
  if(warningIconDiv){
    warningIconDiv.classList.add(classess.warningIconDiv);
  }

  const errorIconDiv = document.querySelector('#okta-sign-in .infobox-error');
  if(errorIconDiv){
    errorIconDiv.classList.add(classess.warningIconDiv);
  }

}
